import axios from 'axios';
import { withOptionalUserApiKeyHeaders } from './apiAuth.ts';

const API_BASE_URL = '/api/drone';

export interface DroneProcessRequest {
  projectId: string;
  imageUrls: string[];
  outputPrefixOverride?: string;
}

export interface DroneProcessResponse {
  project_id: string;
  task_id: string;
  status: string;
  orthophoto_uri: string;
  mesh_obj_uri: string;
  mesh_mtl_uri?: string | null;
  texture_uris: string[];
  warnings: string[];
}

class DroneProcessingService {
  async checkAPIHealth(): Promise<boolean> {
    try {
      const response = await axios.get(`${API_BASE_URL}/readyz`, {
        headers: withOptionalUserApiKeyHeaders(),
        timeout: 10000,
      });
      return response.status === 200 && response.data?.status === 'ready';
    } catch {
      return false;
    }
  }

  async submitDroneJob(request: DroneProcessRequest): Promise<DroneProcessResponse> {
    try {
      const response = await axios.post<DroneProcessResponse>(
        `${API_BASE_URL}/internal/drone/process`,
        {
          project_id: request.projectId,
          image_urls: request.imageUrls,
          output_prefix_override: request.outputPrefixOverride || undefined,
        },
        {
          headers: withOptionalUserApiKeyHeaders({ 'Content-Type': 'application/json' }),
          timeout: 1000 * 60 * 60,
        }
      );

      return response.data;
    } catch (error: any) {
      throw new Error(
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message ||
        'Failed to process drone mapping job'
      );
    }
  }
}

const droneProcessingService = new DroneProcessingService();
export default droneProcessingService;